<template>
  <div class="w-full h-full rounded-t-3xl px-32 pt-12 pb-4 overflow-auto flex flex-col">
    <div>
      <div>
        <div class="flex flex-col gap-1">
          <BaseText
            type="label"
            class="text-neutral-600"
          >
            Plan
          </BaseText>
          <BaseText
            size="sm"
            class="max-w-xs text-neutral-500"
          >
            View and edit your active Foreplay subscription.
          </BaseText>
        </div>
      </div>
    </div>
    <!-- Offers -->
    <div class="space-y-1 mt-7">
      <BaseText
        type="label"
        size="sm"
        class="text-text-muted"
      >
        Current Offers
      </BaseText>
      <div class="grid grid-cols-12 gap-3">
        <div
          v-if="isMonthly"
          class="p-4 space-y-3 rounded-xl border border-border-normal col-span-6"
        >
          <div class="w-6 h-6 rounded-md bg-secondary-green-10 flex items-center justify-center">
            <CouponIcon class="text-secondary-green-100" />
          </div>
          <BaseText
            type="label"
            size="sm"
            class="text-text-muted"
          >
            Switch to an Annual Billing
          </BaseText>
          <div class="space-y-1">
            <div class="flex items-center gap-1">
              <NewCheckmarkIcon class="text-secondary-green-100" />
              <BaseText
                type="body"
                size="sm"
                class="text-text-normal"
              >
                Unlimited Spyder Credits
              </BaseText>
            </div>
            <div class="flex items-center gap-1">
              <NewCheckmarkIcon class="text-secondary-green-100" />
              <BaseText
                type="body"
                size="sm"
                class="text-text-normal"
              >
                Save ${{annualSavings}}/year
              </BaseText>
            </div>
            <div class="flex items-center gap-1">
              <NewCheckmarkIcon class="text-secondary-green-100" />
              <BaseText
                type="body"
                size="sm"
                class="text-text-normal"
              >
                Extra 10,000 API credits/month
              </BaseText>
            </div>
          </div>
          <button
            class="base-btn py-1.5 px-2.5"
            @click="showSubscriptionDrawer"
          >
            <BaseText
              type="label"
              size="sm"
              class="text-text-muted"
            >
              Claim Offer
            </BaseText>
          </button>
        </div>
        <div class="p-4 space-y-3 rounded-xl border border-border-normal" :class="isMonthly ? 'col-span-6' : 'col-span-12'">
          <div class="bg-primary-blue-10 w-6 h-6 rounded-md flex items-center justify-center">
            <CalendarIcon class="text-primary-blue-100" />
          </div>
          <BaseText
            type="label"
            size="sm"
            class="text-text-muted"
          >
            Save up-to 80% with custom pricing
          </BaseText>
          <div class="space-y-1">
            <BaseText
              type="body"
              size="sm"
              class="text-text-normal"
            >
              To qualify you must have;
            </BaseText>
            <div class="flex items-center gap-1">
              <div class="w-5 h-5 flex items-center justify-center">
                <div class="rounded-full border-2 border-primary-blue-100 bg-white w-2 h-2" />
              </div>
              <BaseText
                type="body"
                size="sm"
                class="text-text-normal"
              >
                Over 20 employees
              </BaseText>
            </div>
            <div class="flex items-center gap-1">
              <div class="w-5 h-5 flex items-center justify-center">
                <div class="rounded-full border-2 border-primary-blue-100 bg-white w-2 h-2" />
              </div>
              <BaseText
                type="body"
                size="sm"
                class="text-text-normal"
              >
                Managing more than 5 ad accounts
              </BaseText>
            </div>
          </div>
          <button
            class="base-btn py-1.5 px-2.5"
            @click="redirectToBookCall"
          >
            <BaseText
              type="label"
              size="sm"
              class="text-text-muted"
            >
              Book a Call
            </BaseText>
          </button>
        </div>
      </div>
    </div>
    <!-- Divider -->
    <div class="border-t border-neutral-50 w-full my-7" />
    <!-- Plan Name -->
    <div class="flex justify-between items-center">
      <!-- Left Column -->
      <div class="flex gap-4 items-center">
        <div class="w-14 h-14 p-3.5 border rounded-xl">
          <img
            src="../../assets/icons/foreplay-gray.svg"
            class="w-full h-full"
          >
        </div>
        <div>
          <BaseText
            v-if="hasSubscription"
            class="text-neutral-600 capitalize"
            type="label"
            size="sm"
          >
            {{ basePlan.name }} <span v-if="basePlan?.price">{{ `($${basePlan.price}/${basePlan.interval})` }}</span>
            <span v-if="getTrialState.isActive">(Trial ends in {{ getTrialState.endsIn.days }} days)</span>
          </BaseText>
          <BaseText
            v-else
            class="text-neutral-600"
            type="label"
            size="sm"
          >
            No active subscription
          </BaseText>
          <BaseText
            class="text-neutral-500 mt-1"
            size="sm"
          >
            {{ basePlan.desc }}
          </BaseText>
        </div>
      </div>
      <div class="flex items-center gap-1">
        <!-- Right Column -->
        <div class="relative w-min">
          <BaseButton
            outlined
            :disabled="getTeam && getTeam && !isTeamOwner"
            @click="redirectToManage"
            @mouseenter.native="tooltipHovered.changePlan = true"
            @mouseleave.native="tooltipHovered.changePlan = false"
          >
            Update Plan
          </BaseButton>
          <transition>
            <div
              v-if="tooltipHovered.changePlan && getTeam && !isTeamOwner"
              class="label-tooltip"
            >
              <BaseText
                type="body"
                size="sm"
                class="text-white"
              >
                Only account admins can access this: {{ teamOwnerEmail }}
              </BaseText>
            </div>
          </transition>
        </div>
      </div>
    </div>
    <!-- Add on details -->

    <!-- Divider -->
    <div v-if="apiSubscriptionInfo">
      <div class="w-full my-7" />
      <div class="flex justify-between items-center">
        <!-- Left Column -->
        <div class="flex gap-4 items-center">
          <div class="w-14 h-14 p-3 border rounded-xl flex items-center justify-center">
            <img
              src="../../assets/icons/foreplay-api-icon.svg"
              class="w-full h-full"
            >
          </div>
          <div>
            <BaseText
              class="text-neutral-600"
              type="label"
              size="sm"
            >
              {{ apiSubscriptionInfo.name }}
            </BaseText>
            <BaseText
              class="text-neutral-500 mt-1"
              size="sm"
            >
              {{ apiSubscriptionInfo.desc }}
            </BaseText>
          </div>
        </div>
        <!-- Right Column -->
        <div class="flex items-center gap-1">
          <div class="relative w-min">
            <BaseButton
              outlined
              :disabled="getTeam && getTeam && !isTeamOwner"
              @click="redirectToManageAPI"
              @mouseenter.native="tooltipHovered.changePlanAPI = true"
              @mouseleave.native="tooltipHovered.changePlanAPI = false"
            >
              Update Plan
            </BaseButton>
            <transition>
              <div
                v-if="tooltipHovered.changePlanAPI && getTeam && !isTeamOwner"
                class="label-tooltip"
              >
                <BaseText
                  type="body"
                  size="sm"
                  class="text-white"
                >
                  Only account admins can access this: {{ teamOwnerEmail }}
                </BaseText>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
    <!-- Addons -->
    <div class="mt-7 ml-2">
      <BaseText
        type="label"
        size="sm"
        class="mb-1"
      >
        Add-Ons
      </BaseText>
      <div
        v-if="hasPlanAddOns"
        class="space-y-1"
      >
        <div
          v-for="addOn in basePlan.addOns"
          :key="addOn.name"
        >
          <div
            v-if="addOn.show"
            class="p-1 rounded-lg w-full bg-background-normal flex items-center justify-between"
          >
            <div
              class="flex items-center gap-2 p-1"
            >
              <component
                :is="addOn.icon"
                class="text-text-subdued w-5 h-5"
              />
              <BaseText
                type="label"
                size="sm"
                class="text-text-muted"
              >
                {{ `${addOn.quantity} Additional ${addOn.name}` }}
              </BaseText>
              <BaseText
                v-if="addOn.pricePer"
                size="sm"
                class="text-neutral-500"
              >
                {{ addOn.pricePer }}
              </BaseText>
            </div>
            <button
              class="base-btn py-1.5 px-2.5 h-full"
              :disabled="getTeam && getTeam && !isTeamOwner || addOn.disabled"
              @click="addOn.action"
            >
              <BaseText
                type="label"
                size="sm"
                class="text-text-muted"
              >
                Update
              </BaseText>
            </button>
          </div>
        </div>
      </div>
      <div v-else>
        <BaseText
          class="text-neutral-300"
          size="sm"
        >
          No additional items
        </BaseText>
      </div>
    </div>
    <div class="flex-grow" />
    <div class="border-t border-neutral-50 w-full my-4" />
    <!-- Cancel actions -->
    <div class="flex items-center">
      <BaseButton
        padding-x="0px"
        class="cancel-btn text-text-normal"
        :disabled="getTeam && !isTeamOwner"
        @click="cancelSubscription"
        @mouseenter.native="tooltipHovered.cancelPlan = true"
        @mouseleave.native="tooltipHovered.cancelPlan = false"
      >
        <div class="cancel-btn-content flex items-center gap-1 capitalize px-2 py-1.5 rounded-md transition-colors">
          <CloseCircleIcon class="text-text-normal" />
          Cancel {{ basePlan.name?.split(" ")?.[0] }} Plan
        </div>
      </BaseButton>
      <transition>
        <div
          v-if="tooltipHovered.cancelPlan && getTeam && !isTeamOwner"
          class="label-tooltip"
        >
          <BaseText
            type="body"
            size="sm"
            class="text-white"
          >
            Only account admins can access this: {{ teamOwnerEmail }}
          </BaseText>
        </div>
      </transition>
      <div
        v-if="apiSubscriptionInfo"
        class="w-px bg-background-hover h-5 mx-3"
      />
      <div
        v-if="apiSubscriptionInfo"
      >
        <BaseButton
          padding-x="0px"
          class="cancel-btn text-text-normal"
          :disabled="getTeam && !isTeamOwner"
          @click="cancelAPIsubscription"
          @mouseenter.native="tooltipHovered.cancelPlanAPI = true"
          @mouseleave.native="tooltipHovered.cancelPlanAPI = false"
        >
          <div class="cancel-btn-content flex items-center gap-1 px-2 py-1.5 rounded-md transition-colors">
            <CloseCircleIcon class="text-text-normal" />
            Cancel API Plan
          </div>
        </BaseButton>
        <transition>
          <div
            v-if="tooltipHovered.cancelPlanAPI && getTeam && !isTeamOwner"
            class="label-tooltip"
          >
            <BaseText
              type="body"
              size="sm"
              class="text-white"
            >
              Only account admins can access this: {{ teamOwnerEmail }}
            </BaseText>
          </div>
        </transition>
      </div>
      <div
        v-if="hasSpyderPackage"
        class="w-px bg-background-hover h-5 mx-3"
      />
      <div
        v-if="hasSpyderPackage"
      >
        <BaseButton
          padding-x="0px"
          class="cancel-btn text-text-normal"
          :disabled="getTeam && !isTeamOwner"
          @click="show.cancelSpyderPlan = true"
          @mouseenter.native="tooltipHovered.cancelSpyderPlan = true"
          @mouseleave.native="tooltipHovered.cancelSpyderPlan = false"
        >
          <div class="cancel-btn-content flex items-center gap-1 px-2 py-1.5 rounded-md transition-colors">
            <CloseCircleIcon class="text-text-normal" />
            Cancel Spyder Plan
          </div>
        </BaseButton>
        <transition>
          <div
            v-if="tooltipHovered.cancelSpyderPlan && getTeam && !isTeamOwner"
            class="label-tooltip"
          >
            <BaseText
              type="body"
              size="sm"
              class="text-white"
            >
              Only account admins can access this: {{ teamOwnerEmail }}
            </BaseText>
          </div>
        </transition>
      </div>
    </div>
    <!-- Modals -->
    <TeamSeatModal
      v-if="show.manageTeam"
      :team-allocation="getTeamAllocation"
      @close="show.manageTeam = false"
    />
    <LensAccountModal
      v-if="show.manageLens"
      @close="show.manageLens = false"
    />
    <BuySpyderCreditsModal
      v-if="show.manageSpyder"
      @close="show.manageSpyder = false"
    />
    <BaseConfirmModal
      v-if="show.cancelSpyderPlan"
      :title="`Cancel Spyder Plan`"
      :description="`Are you sure you want to cancel your Spyder plan? You will lose your additional Spyder credits.`"
      :loading="loading.cancelSpyderPlan"
      @confirm="cancelSpyderSubscription"
      @close="show.cancelSpyderPlan = false"
    />
  </div>
</template>

<script>
import FirebaseAPI from '@/api/firebase'
import ForeplayAPI from '@/api/foreplayServer'
import { mapGetters, mapMutations } from 'vuex'
import _ from 'lodash'
import { SUBSCRIPTION_STATES, SUBSCRIPTION_PLANS, LEGACY_SUBSCRIPTION_PLANS } from '@/utils/stripe/productMeta'

// Icons
import ChairIcon from '../globals/Icons/ChairIcon.vue'
import NewCheckmarkIcon from '../globals/Icons/NewCheckmarkIcon.vue'
import CouponIcon from '../globals/Icons/CouponIcon.vue'
import CalendarIcon from '../globals/Icons/CalendarIcon.vue'
import CloseCircleIcon from '../globals/Icons/CloseCircleIcon.vue'
import LensIcon from '../globals/Icons/SidebarIcons/LensIcon.vue'
import SpyderIcon from '../globals/Icons/SidebarIcons/SpyderIcon.vue'

// Components
import LensAccountModal from './lens/LensAccountModal.vue'
import TeamSeatModal from './team/TeamSeatModal.vue'
import BuySpyderCreditsModal from '../spyderV2/BuySpyderCreditsModal.vue'
import BaseConfirmModal from '../globals/BaseConfirmModal.vue'

export default {
  name: 'PlanSettings',
  components: {
    // Components
    LensAccountModal,
    TeamSeatModal,
    BuySpyderCreditsModal,
    BaseConfirmModal,
    // Icons
    ChairIcon,
    NewCheckmarkIcon,
    CouponIcon,
    CalendarIcon,
    CloseCircleIcon,
    LensIcon,
    SpyderIcon
  },
  data () {
    return {
      teamOwnerEmail: '',
      fullworkflowId: 'prod_LfIi8NmO2xjOpY',
      inspiratonId: 'prod_K9H5hPoU2WPBuU',

      show: {
        manageTeam: false,
        manageLens: false,
        manageSpyder: false,
        cancelSpyderPlan: false
      },

      tooltipHovered: {
        changePlan: false,
        changePlanAPI: false,
        cancelPlan: false,
        cancelPlanAPI: false,
        cancelSpyderPlan: false
      },

      loading: {
        cancelSpyderPlan: false
      }
    }
  },
  computed: {
    ...mapGetters('AuthModule', [
      'getUserSubscription',
      'getStripeCustomer',
      'getUser',
      'getTeam',
      'getTeamSubscription',
      'isTeamOwner',
      'getTrialState',
      'getApiSubscription',
      'getIsLegacy',
      'getLensLimit'
    ]),
    hasSpyderPackage () {
      return this.getUserSubscription?.addOns?.spyder?.isFromBasePlan === false
    },
    isMonthly () {
      return this.getUserSubscription?.interval === 'month'
    },
    annualSavings () {
      return SUBSCRIPTION_PLANS.find(plan => plan.key === this.getUserSubscription?.internalProductId)?.annualSavings || 0
    },
    getTeamAllocation () {
      const productPlans = this.getIsLegacy ? LEGACY_SUBSCRIPTION_PLANS : SUBSCRIPTION_PLANS
      const currentTeamCount = this.getTeam?.members?.length || 0
      const paidTeamCount = this.getUserSubscription?.quantity || 0
      const freeTeamCount = productPlans.find(product => product.key === this.getUserSubscription?.internalProductId)?.baseUserCount || 0

      const maxAllocation = Math.max(currentTeamCount, paidTeamCount, freeTeamCount)
      const freeLeftOver = freeTeamCount > currentTeamCount ? freeTeamCount - currentTeamCount : 0
      const paidLeftOver = paidTeamCount - freeTeamCount
      return {
        max: maxAllocation,
        maxFree: freeTeamCount,
        current: currentTeamCount,
        total: paidTeamCount,
        paid: Math.max(paidLeftOver, 0),
        free: Math.max(freeLeftOver, 0),
        showCompact: true
      }
    },
    hasPlanAddOns () {
      return this.basePlan?.addOns?.length > 0
    },
    apiSubscriptionInfo () {
      if (!this.getApiSubscription || this.getApiSubscription?.status !== 'active') return null
      const apiSub = this.getApiSubscription
      return {
        name: apiSub.planName,
        interval: apiSub.interval,
        desc: apiSub.quantity > 0 ? `${apiSub.quantity?.toLocaleString()} API Credits` : 'No API Credits'
      }
    },
    hasSubscription () {
      return this.getUserSubscription?.status === SUBSCRIPTION_STATES.ACTIVE || this.getUserSubscription?.status === SUBSCRIPTION_STATES.TRIALING
    },
    isTrialSubscription () {
      return this.getUserSubscription?.status === 'trialing' || this.getTeamSubscription?.status === 'trialing'
    },
    getTrialDaysLeft () {
      const activeSub = this.getUserSubscription || this.getTeamSubscription
      const endUnixTimestamp = activeSub?.current_period_end?.seconds
      const now = new Date()
      const trialEndTime = new Date(endUnixTimestamp * 1000)
      const diffTime = Math.abs(trialEndTime - now)
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
      return diffDays
    },
    basePlan () {
      const subscription = this.getUserSubscription
      if (!this.hasSubscription) {
        return {
          name: 'No active subscription',
          interval: 'month',
          price: null,
          addOns: []
        }
      }
      const subName = this.getIsLegacy ? subscription?.planName?.replace(/_/g, ' ') : subscription?.planName
      const SubscriptionPlans = this.getIsLegacy ? LEGACY_SUBSCRIPTION_PLANS : SUBSCRIPTION_PLANS

      const currentPlan = SubscriptionPlans.find(plan => plan.key === subscription?.internalProductId)
      const interval = subscription?.interval === 'month' ? { key: 'monthly', code: 'mo' } : { key: 'annual', code: 'yr' }
      const paidMembers = subscription?.quantity - (currentPlan?.baseUserCount || 0)
      const paidLens = (subscription?.addOns?.lens?.quantity || 0) - (currentPlan?.baseLens || 0)
      const paidSpyder = (subscription?.addOns?.spyder?.quantity || 0) - (currentPlan?.baseSpyder?.[interval.key] || 0)
      const memberAddOn = Math.max(paidMembers, 0)
      const lensAddOn = Math.max(paidLens, 0)
      const spyderAddOn = Math.max(paidSpyder, 0)

      const isBasic = subscription?.internalProductId === 'basic_plan'
      const isLegacy = this.getIsLegacy
      const isMonthly = interval.key === 'monthly'

      return {
        name: subName || 'Plan not found',
        interval: interval.key,
        price: null,
        addOns: [
          { key: 'team_seats', show: true, name: 'Team Seats', icon: ChairIcon, pricePer: `$${isMonthly ? 20 : 240} each /${interval.code}`, quantity: memberAddOn, formatQuantity: memberAddOn, action: () => { this.show.manageTeam = true } },
          { key: 'lens_accounts', show: !isBasic && !isLegacy, name: 'Lens Accounts', icon: LensIcon, pricePer: `$${isMonthly ? 49.99 : 499.99} each/${interval.code}`, quantity: lensAddOn, formatQuantity: lensAddOn, action: () => { this.show.manageLens = true } },
          { key: 'brands_tracked', show: !isBasic && isMonthly, name: 'Brands Tracked', icon: SpyderIcon, pricePer: null, quantity: spyderAddOn, formatQuantity: spyderAddOn, action: () => { this.show.manageSpyder = true }, disabled: !isMonthly || isBasic }
        ]
      }
    }
  },
  async mounted () {
    this.teamOwnerEmail = await this.getTeamOwnerEmail()
  },
  methods: {
    ...mapMutations('AuthModule', ['SET_APP_LIMITS', 'SET_USER_SUBSCRIPTION']),
    ...mapMutations('MiscModule', ['SET_SUBSCRIPTION_DRAWER_VIEW_MODE']),
    redirectToBookCall () {
      window.open('https://www.foreplay.co/book-demo', '_blank')
    },
    async getTeamOwnerEmail () {
      const team = this.getTeam
      const owner = await FirebaseAPI.Users.getById(team.created_by)

      return owner.email
    },
    redirectToManageAPI () {
      this.$router.push({ name: 'ApiCreditsView' })
      this.$emit('close')
    },
    redirectToManage () {
      // this.$router.push({ name: 'PaymentView' })
      this.SET_SUBSCRIPTION_DRAWER_VIEW_MODE({ state: true })
      this.$emit('close')
    },
    showSubscriptionDrawer () {
      this.SET_SUBSCRIPTION_DRAWER_VIEW_MODE({ state: true, initInterval: 'annual' })
    },
    async cancelSubscription () {
      // Add specific error handling to pinpoint some customer errors
      if (_.isEmpty(this.getStripeCustomer) || !this.getStripeCustomer?.stripeId) {
        this.$showAlert({ type: 'Error', message: 'Customer ID not found. Please contact support' })
        return
      }
      if (_.isEmpty(this.getUserSubscription)) {
        this.$showAlert({ type: 'Error', message: 'User Subscription not found. Please contact support' })
        return
      }

      const cusId = this.getStripeCustomer?.stripeId
      const sub = this.getUserSubscription
      let data
      try {
        data = await ForeplayAPI.Users.getChurnHash(cusId)
      } catch (e) {
        this.$showAlert({ message: 'Unable to retrieve customer data. Please contact support.', type: 'error' })
        console.error(e)
      }
      const alertCb = (e) => {
        this.$showAlert({ message: e.message, type: 'error' })
      }
      window.churnkey.init('show', {
        subscriptionId: sub.id,
        customerId: cusId,
        authHash: data.hash,
        appId: 'yk5n1rq9q',
        mode: 'live',
        provider: 'stripe',
        handleSupportRequest: customer => {
          const choiceReason = window.churnkey.getSessionData().surveyChoiceValue?.toLowerCase()
          window.Intercom('showNewMessage', `Hi, I'm considering canceling my subscription because of ${choiceReason}`)
          window.churnkey.hide()
        },
        onError (error, type) {
          console.error(error.message)
          alertCb(error)
        }
      })
    },
    async cancelAPIsubscription () {
      // Add specific error handling to pinpoint some customer errors
      if (_.isEmpty(this.getStripeCustomer) || !this.getStripeCustomer?.stripeId) {
        this.$showAlert({ type: 'Error', message: 'Customer ID not found. Please contact support' })
        return
      }
      if (_.isEmpty(this.getApiSubscription)) {
        this.$showAlert({ type: 'Error', message: 'API Subscription not found. Please contact support' })
        return
      }

      const cusId = this.getStripeCustomer?.stripeId
      const sub = this.getApiSubscription
      let data
      try {
        data = await ForeplayAPI.Users.getChurnHash(cusId)
      } catch (e) {
        this.$showAlert({ message: 'Unable to retrieve customer data. Please contact support.', type: 'error' })
        console.error(e)
      }
      const alertCb = (e) => {
        this.$showAlert({ message: e.message, type: 'error' })
      }
      window.churnkey.init('show', {
        subscriptionId: sub.id,
        customerId: cusId,
        authHash: data.hash,
        appId: 'yk5n1rq9q',
        mode: 'live',
        provider: 'stripe',
        handleSupportRequest: customer => {
          const choiceReason = window.churnkey.getSessionData().surveyChoiceValue?.toLowerCase()
          window.Intercom('showNewMessage', `Hi, I'm considering canceling my subscription because of ${choiceReason}`)
          window.churnkey.hide()
        },
        onError (error, type) {
          console.error(error.message)
          alertCb(error)
        }
      })
    },
    async cancelSpyderSubscription () {
      if (this.loading.cancelSpyderPlan) return
      this.loading.cancelSpyderPlan = true
      try {
        await ForeplayAPI.Subscription.cancelSpyderSubscription(this.getUserSubscription.id)

        // Local refresh of subscription
        const isBasic = this.getUserSubscription?.internalProductId === 'basic_plan'
        const baseSpyderLimit = this.getIsLegacy && !isBasic ? 2 : SUBSCRIPTION_PLANS.find(p => p.key === this.getUserSubscription?.internalProductId)?.baseSpyder?.monthly ?? 0
        this.SET_APP_LIMITS({ spyder: baseSpyderLimit, lens: this.getLensLimit })
        const subUpdate = {
          ...this.getUserSubscription,
          addOns: {
            ...this.getUserSubscription.addOns,
            spyder: {
              isFromBasePlan: true,
              quantity: baseSpyderLimit,
              priceId: null,
              productId: null
            }
          }
        }
        this.SET_USER_SUBSCRIPTION(subUpdate)

        this.show.cancelSpyderPlan = false
        this.$showAlert({ message: 'Your Spyder subscription has been cancelled successfully', type: 'success' })
      } catch (e) {
        this.$showAlert({ message: 'Unable to cancel Spyder subscription. Please contact support.', type: 'error' })
        console.error(e)
      } finally {
        this.loading.cancelSpyderPlan = false
      }
    }
  }
}
</script>

<style scoped>
.cancel-btn:hover :deep(.cancel-btn-content) {
  background-color: #FFF0F3;
  color: #710E21;
}

.cancel-btn:hover :deep(.cancel-btn-content svg) {
  color: #710E21;
}

.cancel-btn:disabled :deep(.cancel-btn-content) {
  background-color: transparent;
}

.cancel-btn-content:hover {
  background-color: #FFF0F3;
  color: #710E21;
}

.cancel-btn-content:hover svg {
  color: #710E21;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 150ms ease-in-out;
}

.v-enter-from,
.v-enter,
.v-leave-to {
  opacity: 0;
}

.v-enter-to,
.v-leave-from {
  opacity: 1;
}

.label-tooltip {
  position: absolute;
  left: 50%;
  bottom: calc(100% + 6px);
  transform: translateX(-50%);
  padding: 8px 12px;
  border-radius: 6px;
  color: white;
  background-color: #131520;
  width: 240px;
  text-align: left;
}

.base-btn {
  background: white;
  box-shadow: 0px 1px 2px 0px rgba(4, 26, 75, 0.13),
    0px 0px 0px 1px rgba(0, 56, 108, 0.08);
  transition: box-shadow 100ms ease-in-out, background-color 100ms ease-in-out;
  border-radius: 6px;
  padding: 6px 8px 6px 8px;
}

.base-btn:hover {
  box-shadow: 0px 1px 2px 0px rgba(4, 26, 75, 0.17),
    0px 0px 0px 1px rgba(0, 56, 108, 0.12);
}

.base-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
